/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerProfileDtoModel, CustomerProfileDtoModelType } from "./CustomerProfileDtoModel"
import { CustomerProfileDtoModelSelector } from "./CustomerProfileDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  node: CustomerProfileDtoModelType;
}

/**
 * CustomerProfileDtoEdgeBase
 * auto generated base class for the model CustomerProfileDtoEdgeModel.
 */
export const CustomerProfileDtoEdgeModelBase = withTypedRefs<Refs>()(ModelBase
  .named('CustomerProfileDtoEdge')
  .props({
    __typename: types.optional(types.literal("CustomerProfileDtoEdge"), "CustomerProfileDtoEdge"),
    cursor: types.union(types.undefined, types.string),
    node: types.union(types.undefined, MSTGQLRef(types.late((): any => CustomerProfileDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class CustomerProfileDtoEdgeModelSelector extends QueryBuilder {
  get cursor() { return this.__attr(`cursor`) }
  node(builder: string | CustomerProfileDtoModelSelector | ((selector: CustomerProfileDtoModelSelector) => CustomerProfileDtoModelSelector) | undefined) { return this.__child(`node`, CustomerProfileDtoModelSelector, builder) }
}
export function selectFromCustomerProfileDtoEdge() {
  return new CustomerProfileDtoEdgeModelSelector()
}

export const customerProfileDtoEdgeModelPrimitives = selectFromCustomerProfileDtoEdge().cursor
